<template>

        <el-carousel @change="changeCarousel" :interval="5000" indicator-position="none" arrow="never" style="width: 100%" height="100vh">
          <el-carousel-item v-for="item in bg" :key="item">
            <div :style="'background:url(' + item + ') no-repeat;background-size:cover;background-position:50% 50%'"  style="height: 100vh;"></div>
          </el-carousel-item>
        </el-carousel>

</template>

<script>
export default {
  props: [
    'i18n',
    'config',

    'bg'
  ],
  data: function data() {
    return {
      currentImage: 0,
    }
  },
  created: function created() {
  },
  mounted: function mounted() {
  },
  methods:{
    changeCarousel: function changeCarousel(index){
      this.currentImage=index
    },
  }
}
</script>
